var _circle, _circle2, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7F6FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3510_8355",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0001,
    cy: 16.0001,
    r: 15.4783,
    fill: "white",
    stroke: "#E8EAF1",
    strokeWidth: 0.347826
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3510_8355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 36.0268C23.2999 36.0268 29.2175 32.2359 29.2175 27.5596C29.2175 22.8834 23.2999 19.0925 16.0001 19.0925C8.70034 19.0925 2.78271 22.8834 2.78271 27.5596C2.78271 32.2359 8.70034 36.0268 16.0001 36.0268Z",
    fill: "#D7D9DF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 17.019C18.6893 17.019 20.8695 14.8528 20.8695 12.1806C20.8695 9.50849 18.6893 7.34229 15.9999 7.34229C13.3106 7.34229 11.1304 9.50849 11.1304 12.1806C11.1304 14.8528 13.3106 17.019 15.9999 17.019Z",
    fill: "#D7D9DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIUser);
export default __webpack_public_path__ + "static/media/i_user.28fc420f6f7319f1bfa95cf56a326431.svg";
export { ForwardRef as ReactComponent };